var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCustomerNoInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7792 1H36.0673L48 12.9906L24.9518 38L2 12.9906L13.7792 1Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 13H48",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1L25 38",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 1L25 38",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13L25 1",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 13L25 1",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 39C43.4036 39 49 33.4036 49 26.5C49 19.5964 43.4036 14 36.5 14C29.5964 14 24 19.5964 24 26.5C24 33.4036 29.5964 39 36.5 39Z",
    fill: "#FF5959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9752 30.736L39 17H34L34.9938 30.736H37.9752ZM38.8137 37V32.8427H34.1863V37H38.8137Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCustomerNoInfo);
export default __webpack_public_path__ + "static/media/ico_customer_no_info.17317e0bf34387792f70d3e18f2878a1.svg";
export { ForwardRef as ReactComponent };